<template>
    <b-modal v-model="show" title="БИНО ИНШОАТ ТУРИ">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Парент</label>
                        <treeselect class="form-control"
                            placeholder="Танланг..."
                            :multiple="false"
                             v-model="parentId"
                            :options="buildingSections">
                        </treeselect>
                    </div>
                    <div class="form-group">
                        <label>Текст</label>
                        <input type="text"
                            class="form-control"
                            v-model="data.label"
                        />
                    </div>
                    <div class="form-group">
                        <label>Бино категорияси <span class="red">*</span></label>
                        <select class="form-control" v-model="data.category">
                            <option value="Notorious">НОТУРАР</option>
                            <option value="Residential">ТУРАР</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Бино категорияси тури <span class="red">*</span></label>
                        <select class="form-control" v-model="data.sectionType">
                            <option value="ResidentialMultiStorey">Кўпқаватли бинолар</option>
                            <option value="ResidentialIndividual">Ҳовли жойлар</option>
                            <option value="NotResidential">Нотурар жойлар</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 table-responsive">
                    <label>БИНО ПАРАМЕТРЛАРИ</label>
                    <div class="table-wrapper">
                      <table class="table table-striped">
                          <tbody v-if="fields && fields.length > 0">
                              <tr v-for="field in fields" :key="field.id">
                                  <td width="5%">
                                      <div class="form-check">
                                          <label class="form-check-label">
                                              <input type="checkbox" class="form-check-input" v-model="field.checked">
                                              <span class="form-check-sign"></span>
                                          </label>
                                      </div>
                                  </td>
                                  <td>{{field.name}}</td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_SECTION_REGRESSION_ADD')" @click="save">Сақлаш</button>
            <button class="all-btn delete-btn float-right mr-2" @click="show = false">Бекор қилиш</button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import Treeselect from '@riophae/vue-treeselect';
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            'b-modal': bModal,
            Treeselect: Treeselect
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                buildingSections: [],
                filter: initFilterModel(),
                data: this.initData(),
                parentId: null,
                fields: []
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    label: '',
                    resId: null,
                    active: true,
                    category: '',
                    data: {
                        fields: []
                    },
                    parent: null,
                    sectionType: ''
                }
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('/building/section/tree-item/list')
                ];
                promises.push(this.$http.post('/building/field/list', this.filter));
                Promise.all(promises).then(function (values) {
                    vm.buildingSections = values[0].data;
                    if (values.length >= 2) {
                        vm.fields = values[1].data.data.map((field) => {
                            field.checked = false;
                            return field;
                        });
                        console.log(vm.fields)
                    }
                })
            },
            prepareCustomData(data) {
                if (!data.data) {
                    data.data = {};
                }
                if (!data.data.fields) {
                    data.data.fields = [];
                }
                if (!data.parent) {
                    this.parentId = null
                } else {
                    this.parentId = data.parent.resId
                }

                let field_codes = [];
                if (data.data.fields && data.data.fields.length > 0) {
                    field_codes = data.data.fields;
                }

                this.fields.forEach((field) => {
                    field.checked = field_codes.includes(field.code)
                })
            },
            save() {
                const vm = this;
                this.processing = true;
                this.data.data.fields = this.checkedFieldCodes;

                this.$http.post("/building/section", this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            this.$eventBus.$emit("initSectionList");
                            vm.show = false;
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err)
                    })
            }
        },
        computed: {
            checkedFieldCodes() {
                const fields = [];
                this.fields.forEach((field) => {
                    if (field.checked){
                        fields.push(field.code)
                    }
                });
                return fields;
            },
        },
        created() {
            this.init();
            this.$eventBus.$on("showSectionEditModal", (data) => {
                if (data) {
                    this.prepareCustomData(data);
                    this.data = clone(data)
                } else {
                    this.data = this.initData();
                }
                this.show = true
            })
        }
    }
</script>

<style scoped>

</style>